export function cutStr(str: string, length: number = 30, addEllipsis: boolean = true): string {
    return str.substr(0, length) + (str.length > length && addEllipsis ? '...' : '');
}

export function leadStr(str: string | number, symbol: string, size: number) {
    str = str.toString();
    return symbol.repeat(size - str.length) + str;
}
